import { Controller } from 'stimulus';

// Generic image lightbox. Opens any inline <img> inside the element in a fullscreen
// overlay: clicking an image enlarges it; clicking the backdrop, the close button, or
// pressing Esc dismisses it. Attach with data-controller="components--lightbox" to any
// container whose images should be zoomable (post bodies, ticket descriptions, notes…).
export default class extends Controller {
  connect() {
    this.images = Array.from(this.element.querySelectorAll('img'));
    this.onImageClick = this.open.bind(this);
    this.images.forEach((image) => {
      image.classList.add('cursor-zoom-in');
      image.addEventListener('click', this.onImageClick);
    });
    this.onKeydown = this.handleKeydown.bind(this);
  }

  disconnect() {
    this.images.forEach((image) => image.removeEventListener('click', this.onImageClick));
    this.close();
  }

  open(event) {
    this.close();

    const overlay = document.createElement('div');
    overlay.className = 'fixed inset-0 z-[9999] flex items-center justify-center bg-black/85 p-4 sm:p-8';

    const enlarged = document.createElement('img');
    enlarged.src = event.currentTarget.src;
    enlarged.alt = event.currentTarget.alt || '';
    enlarged.className = 'max-h-full max-w-full rounded-xl object-contain shadow-2xl';

    const closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className =
      'absolute top-4 right-4 grid place-items-center w-10 h-10 rounded-full bg-white/10 text-white hover:bg-white/20';
    closeButton.innerHTML = '<i class="fas fa-times text-lg"></i>';

    overlay.appendChild(enlarged);
    overlay.appendChild(closeButton);
    overlay.addEventListener('click', (clickEvent) => {
      if (clickEvent.target !== enlarged) this.close();
    });

    document.body.appendChild(overlay);
    document.addEventListener('keydown', this.onKeydown);
    this.overlay = overlay;
  }

  handleKeydown(event) {
    if (event.key === 'Escape') this.close();
  }

  close() {
    if (!this.overlay) return;
    this.overlay.remove();
    this.overlay = null;
    document.removeEventListener('keydown', this.onKeydown);
  }
}
